import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { MEUCUPOM_URL } from '../../constants/urls';

const SITE = 'Meu Cupom';

// Páginas estáticas. Rotas dinâmicas (loja/categoria, clubes) definem
// o próprio título em Default.jsx / ClubeDoAluno.jsx.
const SEO = {
  '/': {
    title: `${SITE} | Cupom de Desconto, Ofertas e Cashback`,
    description: 'Encontre cupons de desconto, ofertas e cashback das melhores lojas online. Economize em cada compra com o Meu Cupom.',
  },
  '/clubes': {
    title: `${SITE} | Clubes de Vantagens e Descontos`,
    description: 'Conheça os clubes de vantagens do Meu Cupom e aproveite descontos e cashback exclusivos.',
  },
  '/lojas': {
    title: `Todas as Lojas com Cupom de Desconto | ${SITE}`,
    description: 'Veja todas as lojas parceiras com cupons de desconto e cashback no Meu Cupom.',
  },
  '/categorias': {
    title: `Categorias de Cupons e Ofertas | ${SITE}`,
    description: 'Navegue por categorias e encontre cupons de desconto de moda, eletrônicos, viagens, beleza e muito mais.',
  },
  '/devolve': {
    title: `Meu Cupom Devolve | Cashback em suas compras`,
    description: 'Ganhe dinheiro de volta nas suas compras online com o Meu Cupom Devolve.',
  },
  '/top-cashback': {
    title: `Top Cashback | ${SITE}`,
    description: 'As lojas com os maiores percentuais de cashback do momento no Meu Cupom.',
  },
  '/top-cupons': {
    title: `Top Cupons de Desconto | ${SITE}`,
    description: 'Os melhores cupons de desconto do momento reunidos em um só lugar. Economize com o Meu Cupom!',
  },
  '/ajuda/perguntas-frequentes': {
    title: `Perguntas Frequentes | ${SITE}`,
    description: 'Tire suas dúvidas sobre cupons, cashback e como usar o Meu Cupom.',
  },
  '/ajuda/como-utilizar-um-cupom': {
    title: `Como Utilizar um Cupom de Desconto | ${SITE}`,
    description: 'Passo a passo para copiar e aplicar um cupom de desconto na sua compra.',
  },
  '/institucional/quem-somos': {
    title: `Quem Somos | ${SITE}`,
    description: 'Conheça o Meu Cupom, plataforma de cupons de desconto e cashback.',
  },
  '/institucional/imprensa': {
    title: `Imprensa | ${SITE}`,
    description: 'Notícias e materiais de imprensa do Meu Cupom.',
  },
  '/institucional/contato': {
    title: `Contato | ${SITE}`,
    description: 'Fale com a equipe do Meu Cupom.',
  },
  '/institucional/termos-de-uso': {
    title: `Termos de Uso | ${SITE}`,
    description: 'Termos de uso do Meu Cupom.',
  },
  '/institucional/politica-de-privacidade': {
    title: `Política de Privacidade | ${SITE}`,
    description: 'Saiba como o Meu Cupom trata seus dados pessoais e cookies.',
  },
  '/jobs': {
    title: `Trabalhe Conosco | ${SITE}`,
    description: 'Vagas e oportunidades de carreira no Meu Cupom.',
  },
  '/redefinir-senha': {
    title: `Redefinir senha | ${SITE}`,
    description: 'Crie uma nova senha para acessar sua conta no Meu Cupom.',
  },
};

const SeoByRoute = () => {
  const { pathname } = useLocation();
  const key = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  const seo = SEO[key];

  if (!seo) return null;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={`${MEUCUPOM_URL}${key === '/' ? '/' : key}`} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="pt_BR" />
    </Helmet>
  );
};

export default SeoByRoute;
